import React from 'react';

const Footer = () => (
  <div className="footer">
    <div>
      <strong>Copyright</strong> Tron Informática Ltda &copy; {new Date().getFullYear()}
    </div>
  </div>
);

export default Footer;
